var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49984 1.16602C9.40599 1.16602 10.275 1.52598 10.9158 2.16673C11.5565 2.80748 11.9165 3.67653 11.9165 4.58268C11.9165 5.48884 11.5565 6.35788 10.9158 6.99863C10.275 7.63938 9.40599 7.99935 8.49984 7.99935C7.59368 7.99935 6.72464 7.63938 6.08389 6.99863C5.44314 6.35788 5.08317 5.48884 5.08317 4.58268C5.08317 3.67653 5.44314 2.80748 6.08389 2.16673C6.72464 1.52598 7.59368 1.16602 8.49984 1.16602ZM13.8159 12.0517C15.1799 12.7338 15.8332 13.5837 15.8332 14.3743V15.8327H1.1665V14.3743C1.1665 13.5837 1.81979 12.7338 3.18381 12.0517C4.51805 11.3846 6.39661 10.9577 8.49984 10.9577C10.6031 10.9577 12.4816 11.3846 13.8159 12.0517Z",
    fill: "#C7C9C7",
    stroke: "#C7C9C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.4db58d6a.svg";
export { ForwardRef as ReactComponent };